<template>
	<div>
		<div class="container py-5">
			<div class="row">
				<div class="col-12n h1 text-dark-pink">
					Modulos de actividades programadas
				</div>
				<div class="col-12">
					<p class="text-blue">
						La Universidad es un mundo nuevo, lleno de oportunidades y queremos que los descubras desde
						el primer día, los siguientes módulos te ofrecerán información importante sobre algunas
						Unidades y Servicios que ofrece la Universidad de Aysén para ti.
					</p>
				</div>
			</div>
			<div class="row justify-content-center">
				<div v-for="modulo in modulos"
				     class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4">
					<link-to :to="{name: 'actividades-modulo', params: {modulo: modulo.route}}" a-class="">
						<div class="zoom-in modulo w-100 h-100 rounded-3 p-3">
							<div class="container-fluid h-100">
								<div class="row h-100">
									<div class="col-8 h-100 d-flex align-items-center">
										<span class="text-white h5" v-html="modulo.title"></span>
									</div>
									<div class="col-4 h-100 d-flex align-items-center justify-content-center">
										<img :src="'/assets/images/iconos-modulos/' + modulo.image"
										     class="w-100"
										     draggable="false"
										     :alt="modulo.title"/>
									</div>
								</div>
							</div>
						</div>
					</link-to>
				</div>
			</div>
		</div>
		<banda-ver-saludos/>
	</div>
</template>

<script>
import BandaVerSaludos from "../layout/BandaVerSaludos";
import {Mock} from "../common/mock";

export default {
	name: "actividades",
	components: {BandaVerSaludos},
	mounted() {
	
	},
	data: () => ({
		modulos: Mock.modulos,
	}),
	methods: {
		createURLImage(image) {
			return '/assets/images/modulos-2023/' + this.key + '/' + image;
		},
		createURLPdf(pdf) {
			return '/assets/images/modulos-2023/' + this.key + '/' + pdf;
		},
	}
}
</script>